import { useGetStructureNameQuery } from '@/__generated__/graphql';
import { useRouter } from '@/hooks';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { Stack } from '@mui/material';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { ActionButton, DeploymentTitle } from '../styles';
import { useDownloadReport } from '../hooks/useDownloadReport';

export const Header = () => {
  const router = useRouter();
  const structureId = useGetStructureId();

  const { data: structureName } = useGetStructureNameQuery({
    variables: {
      structureId: structureId,
    },
    fetchPolicy: 'cache-first',
    skip: !structureId,
  });

  const { handleDownloadReport } = useDownloadReport(
    structureId,
    structureName?.structure?.name ?? ''
  );

  const handle3DView = () => {
    router.push(`/asset-labelling/${structureId}/viewer`);
  };
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <DeploymentTitle>{structureName?.structure?.name}</DeploymentTitle>
      <Stack direction="row" alignItems="center" gap="1.6rem">
        <ActionButton onClick={handle3DView}>
          <AbyssIcon iconName="cube-secondary" style={{ width: '1.8rem', height: '1.8rem' }} />
          <span>View 3D</span>
        </ActionButton>
        <ActionButton contained onClick={handleDownloadReport}>
          <AbyssIcon
            iconName="file-download-line-secondary"
            style={{ width: '1.8rem', height: '1.8rem' }}
          />
          <span>Download report</span>
        </ActionButton>
      </Stack>
    </Stack>
  );
};
